import axios from 'axios';

export const HTTPMTN = axios.create({
  baseURL: `https://la3bttna.com/MTNAPIs_Albatros/APIs/`
})
